import {emptyGuid} from "../../../../Utilities/commonUtilities";
import {convertDateToPrintString} from "../../../../Utilities/Types/dateUtilities";

export const emptyLoanLibraryHistoryModel = {
    loanId: emptyGuid,
    catalogItemTitle: "",
    catalogNumber: "",
    serialNumber: "",
    patronName: "",
    studentName: "",
    shippingLocationName: "",
    checkedOutDate: null,
    dueDate: null,
    dateReturned: null,
    loanLibraryLoanStatus: null,
    statusDisplay: "",
    isOverdue: false,
    daysOverdue: 0,
    notes: "",
};

export const loanLibraryHistory = (loanLibraryHistoryItem: Record<string, any>) => {
    const checkedOutDate = loanLibraryHistoryItem?.checkedOutDate || null;
    const dueDate = loanLibraryHistoryItem?.dueDate || null;
    const dateReturned = loanLibraryHistoryItem?.dateReturned || null;
    
    return {
        ...emptyLoanLibraryHistoryModel,
        ...loanLibraryHistoryItem,
        checkedOutDate: checkedOutDate,
        checkedOutDateFormatted: checkedOutDate ? convertDateToPrintString(checkedOutDate) : "",
        dueDate: dueDate,
        dueDateFormatted: dueDate ? convertDateToPrintString(dueDate) : "",
        dateReturned: dateReturned,
        dateReturnedFormatted: dateReturned ? convertDateToPrintString(dateReturned) : "",
    };
};
